export enum Stage {
    Dev = 'Dev',
    Int = 'Int',
    Prod = 'Prod',
    Local = 'Local',
}
